import React, {useState, useEffect, useCallback, useContext} from "react";
import {Form, Select, Switch} from "antd";
import TableFilterControlsSection from "@common/TableFilterControlsSection";
import {debounce} from "lodash";
import {BrandContext} from "@context/BrandContext";

const TestFilters = props => {
    const {
        popupMatchSelectWidth= true,
        onUpdate,
        onLoadComplete
    } = props;

    const brandConfig = useContext(BrandContext),
        [difficultyLevelOptions, setDifficultyLevelOptions] = useState([]);


    const debouncedInputChange = useCallback(
        debounce((e) => {
            handleChange();
        }, 500), []);

    useEffect(()=>{
        let testDifficultyLevels = [];
        const questionLevelCount = brandConfig.testQuestionLevels;
        if(questionLevelCount && questionLevelCount > 0){
            const levelNames = brandConfig.testQuestionLevelNames;
            for(let i = 0; i < questionLevelCount; i++){
                testDifficultyLevels.push({key:(i+1), value:levelNames[i]});
            }
        }
        setDifficultyLevelOptions(testDifficultyLevels);
        onLoadComplete?.();
    },[]);

    const handleChange = ()=>{
        onUpdate?.();
    }

    return (
            <TableFilterControlsSection key="test-filters" showDivider={false}>
                <Form.Item label="Difficulty"
                           name="testDifficultyLevel"
                >
                    <Select onChange={handleChange} popupMatchSelectWidth={popupMatchSelectWidth}>
                        <Select.Option key={'All'}>All</Select.Option>
                        {difficultyLevelOptions.map((option)=>{
                            return <Select.Option key={option.key}>{option.value}</Select.Option>;
                        })}
                    </Select>
                </Form.Item>
                {/*// TODO add question tags for questions if you want to add this functionality to 'Test' type assessments.*/}
                {/*<Form.Item label="Keyword"*/}
                {/*           name="questionTags"*/}
                {/*           className={'padding-b--s'}*/}
                {/*>*/}
                {/*    <Input className={'margin-t--s'} allowClear onChange={debouncedInputChange}/>*/}
                {/*</Form.Item>*/}
                <Form.Item
                    name="filterCategory"
                    label={'Category'}
                >
                    <Select
                        mode="multiple"
                        onChange={handleChange}
                    >
                        <Select.Option value="exclusive-to-tests">{'Exclusive to '+brandConfig.testsName.toLowerCase()}</Select.Option>
                        {/* Need to change heading if more options are added contentCategory in TeacherTests.js is the example */}
                    </Select>
                </Form.Item>
            </TableFilterControlsSection>
    );
}

export default TestFilters;